// extracted by mini-css-extract-plugin
module.exports = {"battery-backup-Instant":"Instant_battery-backup-Instant__Re5O4"};